<div class="card panel-flat-color secondary-panel">
    <div class="ws-flex-container-horizontal">
        <div class="panel-flat-header ws-flex-grow"
             (click)="expandOrCollapse()"
             [ngClass]="{ 'pointer': !editMode }"
             style="align-items: baseline;">
            <panel-chevron [showBody]="isShowInfo"></panel-chevron>
            <h3>Return Settings</h3>
        </div>
        @if (isShowInfo) {
            <div class="panel-flat-header">
                <div class="float-end header-button-container">
                    @if (allowEdit && !editMode && !editLock) {
                        <button class="ace-btn btn-text has-icon"
                                (click)="setEditMode()">
                            <i class="fa fa-pencil"></i>
                        </button>
                    }
                    @if (editMode) {
                        <button class="ace-btn btn-text has-icon" (click)="save()" [disabled]="!hasChanges">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="ace-btn btn-text has-icon" (click)="cancelEdit()">
                            <i class="fa fa-close"></i>
                        </button>
                    }
                </div>
            </div>
        }
    </div>
    @if (isShowInfo) {
        <div class="card-body">
            @if (isLoading) {
                <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
            }
            @if (busyIndicatorMessageManager.count() > 0) {
                <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
            }
            <return-settings [entityId]="companyId"
                             [entityType]="ReturnSettingsEntityTypeEnum.Company"
                             (onInitialized)="onReturnSettingsInitialized()"
                             (changed)="onReturnSettingsChanged($event)">
            </return-settings>
        </div>
    }
</div>
